export default __webpack_public_path__ + "7ca1aa1.png";